import React from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Grid,
  IconButton,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";
import { truncateComment } from "utils/utils";
import { billingType } from "utils/enumObj";
import Confirm from "assets/images/Confirm.svg";
import DownloadIcon from "assets/images/DownloadBlue.svg";
import pdf from "assets/images/pdf.svg";
import word from "assets/images/doc.svg";

const ConfirmModal = ({ open, toggle, navigate, pageName, companyProfile, pageType }) => {

  const bookingDetails = useSelector(
    (state) => state?.addBooking?.addBookingResponse?.data
  );

  const dutyTypeDetails = bookingDetails?.childData;

  const handlePage = () => {
      toggle();

      if(pageName === "reservation") {
        navigate("/front-desk/all");
      }
  };

  const documents = companyProfile?.Contracts?.[0]?.Agreements;
  const contractText = companyProfile?.Contracts?.[0]?.AdditionalDocuments;

  const HandleAgreement = ({agreement, key}) => {

    let agreementFileName =  agreement?.file?.name || agreement?.agreement?.name || "";
    let agreementFileUrl = agreement?.agreement?.url || agreement?.file?.url;

    let fileName = agreementFileName;
    let fileType = fileName.split(".").pop();

    return (
      <Grid item xs={12} className="bgViolet justifyBetween mb10" key={key}>
        <Tooltip title={agreementFileName} placement="bottom">
          <Box className="p20 marginBlock10 alignItemsCenter">
            <img
              src={fileType === "pdf" ? pdf : word}
              alt="Download Icon"
              className=""
            />
            <Typography
              variant={"body2"}
              className="colorBlack flexDisplay fw400"
            >
              {truncateComment(agreementFileName, 20)}
            </Typography>
          </Box>
        </Tooltip>
        <a href={agreementFileUrl} download={agreementFileName} target="_blank">
          <img src={DownloadIcon} alt="ArrowDown" className="cursor p20" />
        </a>
      </Grid>
    );
  };

  return (
    <Modal
      open={open || false}
      onClose={handlePage}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="customModal"
    >
      <Box
        className={`modalContent textCenter`}
      >
        <Box className={`${pageName === "companyDetails" ? "companyPdfModal" : pageName === "accountDeletionModal" ? "accountDeletionMod" : ""}`}>
        <Box className="closeIcon justifyEnd">
          <IconButton aria-label="close" onClick={handlePage}>
            <CloseIcon />
          </IconButton>
        </Box>
        {pageName === "companyDetails" && (
          <Typography
            variant="head3"
            className="justifyBetween mb10 fw600 colorPrimary"
          >
            New Contract Documents&nbsp;
          </Typography>
        )}
        {pageName !== "companyDetails" && (
          <Box className="justify-items-center">
            <img src={Confirm} alt="Confirm" />
          </Box>
        )}
        {pageName === "companyDetails" && (
          <>
            {companyProfile?.Contracts?.[0]?.Agreements?.length > 0 ? (
              <Grid container className="heightModelScroll">
                {contractText.length > 0 && (
                  <Typography
                    variant="body1"
                    className="justifyBetween mb10 colorGrey"
                  >
                    Contracts
                  </Typography>
                )}

                {companyProfile?.Contracts?.[0]?.Agreements?.map(
                  (agreement, index) => {
                    if (agreement.id) {
                      return <HandleAgreement agreement={agreement} key={index} />;
                    }
                    return null;
                  }
                )}
                {documents?.length > 0 && (
                  <Typography
                    variant="body1"
                    className="justifyBetween mb10 colorGrey"
                  >
                    Other Documents
                  </Typography>
                )}

                {companyProfile?.Contracts?.[0]?.AdditionalDocuments?.map(
                  (agreement, index) => {
                    if (agreement.id) {
                      return <HandleAgreement agreement={agreement} key={index} />;
                    }
                    return null;
                  }
                )}
              </Grid>
            ) : (
              <CommonNoDataFound />
            )}
          </>
        )}
        {pageName === "reservation" && (
          <>
            <Typography variant={"head3"} className="fw600 mb10">
              <span className="colorPrimary">Reservation</span>
              {bookingDetails?.childData?.billingType === billingType?.billToCreditCard ? 
              <span className="colorYellow pl10">Done</span> :
              <span className="colorYellow pl10">Confirm</span>
            }
            </Typography>
            <Typography
              variant={"body2"}
              component={"h6"}
              className="fw400 mb10"
            >
              Booking ID - {bookingDetails?.trip?.tripId}
            </Typography>
            <Tooltip
              title={bookingDetails?.trip?.sourceAddress || bookingDetails?.trip?.sourceLandMarkAddress}
              placement="bottom"
            >
              <Typography
                variant={"body3"}
                component={"h6"}
                className="fw400 colorGrey mb10"
              >
                From -&nbsp;
                {truncateComment(
                  bookingDetails?.trip?.sourceAddress || bookingDetails?.trip?.sourceLandMarkAddress,
                  30
                ) || "NA"}
              </Typography>
            </Tooltip>

            {bookingDetails?.parentTrip?.sourceLandMarkAddress && 
              <Tooltip
              title={bookingDetails?.parentTrip?.sourceLandMarkAddress}
              placement="bottom"
            >
              <Typography
                variant={"body3"}
                component={"h6"}
                className="fw400 colorGrey mb10"
              >
                Landmark -&nbsp;
                {truncateComment(
                  bookingDetails?.parentTrip?.sourceLandMarkAddress,
                  30
                ) || "NA"}
              </Typography>
            </Tooltip>
            }
            
            {(dutyTypeDetails?.tripAddress ||
              dutyTypeDetails?.destinationAddress) && (
              <Tooltip
                title={
                  dutyTypeDetails?.tripAddress ||
                  dutyTypeDetails?.destinationAddress
                }
                placement="bottom"
              >
                <Typography
                  variant={"body3"}
                  component={"h6"}
                  className="fw400 colorGrey mb10"
                >
                  To -&nbsp;
                  {dutyTypeDetails.destinationAddress
                    ? truncateComment(dutyTypeDetails.destinationAddress, 30)
                    : truncateComment(dutyTypeDetails.tripAddress, 30)}
                </Typography>
              </Tooltip>
            )}
            {bookingDetails?.childData?.billingType === billingType?.billToCreditCard && (
              <Typography
                variant={'head5'}
                component={'h6'}
                className="fw500 mb10 width600 colorBlack"
              >
                To confirm your booking, kindly proceed with the payment process
                using the link sent via email.
              </Typography>
            )}
            <Typography
              variant={"head5"}
              component={"h6"}
              className="fw600 colorBlack"
            >
              Ride details will shared with {bookingDetails?.passengerName || "NA"}
            </Typography>
          </>
        )}

        {pageName === "accountDeletionModal" && (
          <>
            <Typography variant={"head3"} className="fw600 mb10">
              <span className="colorPrimary">Request</span>
              <span className="colorYellow pl10">Sent</span>
            </Typography>
            <Typography
                variant={'head5'}
                component={'h6'}
                className="fw500 mb10 width600 colorBlack"
              >
                Our support team will reach out to you
              </Typography>
          </>
        )}    
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmModal;
